<script>
import Multiselect from 'vue-multiselect'
import BotChannelForm from '@components/bot-channel-form'


export default {

    components: {
        Multiselect, BotChannelForm
    },

    props: {
        params: { type: Object },
        bot_uuid: { type: String },
    },

    data() {
        return {
            trackByAction: 'code',
            channelModal: false,

            form_bot_channel_uuid: null, 
            form_channel_uuid: null,
            form_channel_code: null,
            bot_channel_form_key: 0,
            channelModalTitle: 'Канал коммуникаций'
        }
    },

    watch: {
        
    },

    computed: {
        channels_list_data(){
            return this.$store.getters['channels/GET_CHANNELS_LIST_DATA'];
        },
        bot_channels_list_data(){
            return this.$store.getters['botsChannels/GET_BOTS_CHANNELS_LIST_DATA'];
        }
    },

    async mounted() {
        await this.$store.dispatch('channels/FETCH_CHANNELS_LIST', {'filter': 'active', 'filterOn': JSON.stringify(['status'])});
        await this.$store.dispatch('botsChannels/FETCH_BOTS_CHANNELS_LIST', {'filter': this.bot_uuid, 'filterOn': JSON.stringify(['bot_uuid'])});
    },

    methods: {
        get_channel_card_style(code){
            switch (code) {
                case 'telegram': return {icon: 'tg.svg', color: '#2da4d7'}
                case 'viber': return {icon: 'vb.svg', color: '#7f4da0'}
                case 'vk': return {icon: 'vk.svg', color: '#4680c2'}
                case 'ok': return {icon: 'ok.svg', color: '#f68634'}
                case 'whatsapp': return {icon: 'wa.svg', color: '#25d366'}
                case 'sms': return {icon: 'sms.svg', color: '#fd5d4f'}
                case 'wechat': return {icon: 'wechat.svg', color: '#00be57'}
                case 'fb_messenger': return {icon: 'fb-messenger.svg', color: '#0088FF'}
                case 'phone': return {icon: 'phone.svg', color: '#6c7a96'}                
                default: return {icon: null, color: 'none'}
            }
        },

        show_bot_channel_form(channel_code, channel_uuid, channel_name, bot_channel_uuid=null){
            
            // console.log(channel_code);
            // console.log(channel_uuid);
            // console.log(bot_channel_uuid);
            
            this.form_bot_channel_uuid = bot_channel_uuid;
            this.form_channel_uuid = channel_uuid;
            this.form_channel_code = channel_code;
            
            this.bot_channel_form_key = this.bot_channel_form_key + 1;
            this.channelModalTitle = channel_name;
            this.channelModal = true;
        },

        close_bot_channel_form(){
            this.channelModal = false;
        },

        async del_bot_channel(uuid){
            await this.$store.dispatch('botsChannels/FETCH_BOTS_CHANNELS_DELETE', {uuid: uuid});
            await this.$store.dispatch('botsChannels/FETCH_BOTS_CHANNELS_LIST', {'filter': this.bot_uuid, 'filterOn': JSON.stringify(['bot_uuid'])});
        }
    }
}
</script>

<template>
    <div style="border: none; max-width: 900px; margin: 20px; margin-left: 0px; margin-right: 0px; border-top: 1px solid rgba(0, 0, 0, 0.125) !important">

        <h5 style="margin-top: 35px">Подключить новый канал</h5>
        <div class="row ml-1" style="margin-top: 20px">
            <a v-for="(channel, index) in channels_list_data" v-if="channel.code !== 'api' && channel.fl_default !== true" class="m-1 channel-card" href="#" @click="show_bot_channel_form(channel.code, channel.uuid, channel.name)" style="width: 95px; height: 95px; border-radius: 10px; border: 1px solid rgb(138 138 138 / 13%); display: flex !important; flex-flow: column nowrap; justify-content: center; align-items: center; color:#4b4b5a !important; font-size: 12px; ">
                <div :style="'margin-top: 5px; margin-bottom: 5px; display:flex; justify-content:center; align-items:center; width: 40px; height: 40px; border-radius: 10px; background-color: ' + get_channel_card_style(channel.code).color">
                    <img v-if="get_channel_card_style(channel.code).icon" :src="require('@assets/images/channels-icns/' + get_channel_card_style(channel.code).icon)" style="height: 50%" alt="">
                </div>
                <span>{{ channel.name }}</span>
            </a>
        </div>

        <h5 style="margin-top: 35px">Активные каналы</h5>
        <div class="row ml-1" style="margin-top: 20px">
            <div v-for="(bot_channel, index) in bot_channels_list_data" v-if="bot_channel.channel_code !== 'api'" class="channel-card pl-2" style="position:relative; width: 95%; margin-right: 10px; margin-bottom: 10px; width: 95%; height: 65px; border-radius: 10px; border: 1px solid rgb(138 138 138 / 13%); display: flex !important; flex-flow: row wrap; align-items: center; color:#4b4b5a !important; font-size: 12px; ">
                <div :style="'margin-left: 5px; margin-right: 15px; margin-top: 5px; margin-bottom: 5px; display:flex; justify-content:center; align-items:center; width: 40px; height: 40px; border-radius: 10px; background-color: ' + get_channel_card_style(bot_channel.channel_code).color">
                    <img v-if="get_channel_card_style(bot_channel.channel_code).icon" :src="require('@assets/images/channels-icns/' + get_channel_card_style(bot_channel.channel_code).icon)" style="height: 50%" alt="">
                </div>
                <span>{{ bot_channel.channel_name }}<br><span style="font-size: 10px">ID канала: {{ bot_channel.id }}</span></span>
                <div v-if="bot_channel.channel_fl_default !== true" style="width: 90px; float:right; position: absolute; right: 15px">
                    <a href="#" @click="del_bot_channel(bot_channel.uuid)" class="btn btn-outline-danger" style="font-size:12px; padding: 5px; padding-left: 7px; padding-right: 7px; float:right">
                        <i class="uil uil-trash"></i>
                    </a>
                    <a href="#" @click="show_bot_channel_form(bot_channel.channel_code, bot_channel.channel_uuid, bot_channel.channel_name, bot_channel.uuid)" class="btn btn-white" style="font-size:12px; padding: 5px; padding-left: 7px; padding-right: 7px; float:right; margin-right: 7px">
                        <i class="uil uil-sliders-v-alt "></i>
                    </a>
                </div>
            </div>
        </div>

        <div class="row" style="margin-top: 40px">
            <div class="col-12">
                <button class="btn btn-light" @click="$emit('close')">Закрыть</button>                
            </div>
        </div>

        <b-modal
            v-model="channelModal"
            centered
            size="lg"
            :title="channelModalTitle"
            title-class="font-18"
            hide-footer            
        >
            <BotChannelForm 
                :key="bot_channel_form_key"
                :bot_channel_uuid="form_bot_channel_uuid" 
                :channel_uuid="form_channel_uuid"
                :channel_code="form_channel_code"
                :bot_uuid="bot_uuid"
                @close="close_bot_channel_form"
            />
        </b-modal>

    </div>
</template>

<style>
    .draggable h5 {
        cursor: grab;
    }
    .channel-card {
        transition: all .3s;
    }
    .channel-card:hover {
        border-color: rgba(101, 100, 100, 0.05) !important;
        background-color: rgba(185, 185, 185, 0.13);
    }
</style>